module.exports = __webpack_public_path__ + "static/img/saiyisao.f362f079.png";